// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3U9ar","empty":"ModalGraph_empty__1eIQo"};